import React, { useEffect, useState, useCallback } from 'react';
import './RecordingCountdown.css';

interface RecordingCountdownProps {
  onComplete: () => void;
}

/**
 * 3-2-1 countdown overlay before recording starts.
 * Renders as an absolute overlay — parent must be positioned.
 */
export const RecordingCountdown: React.FC<RecordingCountdownProps> = ({ onComplete }) => {
  const [count, setCount] = useState(3);

  const stableComplete = useCallback(onComplete, [onComplete]);

  useEffect(() => {
    if (count <= 0) {
      stableComplete();
      return;
    }
    const timer = setTimeout(() => setCount(c => c - 1), 800);
    return () => clearTimeout(timer);
  }, [count, stableComplete]);

  if (count <= 0) return null;

  return (
    <div className="rc-overlay">
      <div className="rc-number" key={count}>{count}</div>
    </div>
  );
};
